"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFragment = void 0;
var slate_1 = require("slate");
var Utils_1 = require("../Utils");
var EditorWidgetRegistry_1 = require("../WidgetRegistry/EditorWidgetRegistry");
var lodash_1 = require("lodash");
var tiny_invariant_1 = __importDefault(require("tiny-invariant"));
var Text_1 = require("@CommonFrontend/ContentTokens/DataModels/Text");
var getFragment = function (editor) {
    var fragmentRange = editor.selection;
    (0, tiny_invariant_1.default)(!!fragmentRange, "getFragment should only be invoked with a selection");
    var _a = __read(slate_1.Range.edges(fragmentRange), 2), start = _a[0], end = _a[1];
    var endNearestBlock = (0, Utils_1.getClosestBlock)(editor, end.path);
    (0, tiny_invariant_1.default)(!!endNearestBlock, "getFragment couldn't find end block");
    var endNearestLayoutPath = slate_1.Path.parent(endNearestBlock[1]);
    var endNearestLayout = slate_1.Node.get(editor, endNearestLayoutPath);
    var inAccordionHeading = slate_1.Element.isElement(endNearestLayout) && endNearestLayout.type === "accordionHeading";
    if (inAccordionHeading) {
        var accordionHeadingEnd = slate_1.Editor.end(editor, endNearestLayoutPath);
        var nearestAccordionEntry = slate_1.Editor.parent(editor, endNearestLayoutPath);
        if (!nearestAccordionEntry) {
            throw new Error("Couldn't find accordion parent from accordion heading");
        }
        var nearestAccordion = (0, Utils_1.as)("accordion", nearestAccordionEntry[0]);
        var startInAccordionHeading = slate_1.Path.isAncestor(endNearestLayoutPath, start.path);
        if (slate_1.Point.equals(end, accordionHeadingEnd) && !startInAccordionHeading) {
            var accordionIsCollapsed = !nearestAccordion.data.expanded;
            if (accordionIsCollapsed) {
                fragmentRange = {
                    anchor: start,
                    focus: slate_1.Editor.end(editor, nearestAccordionEntry[1]),
                };
            }
        }
    }
    var fragment = (0, lodash_1.cloneDeep)(slate_1.Node.fragment(editor, fragmentRange));
    var patchFragment = function (children, fragmentChildren, path) {
        var _a;
        var fragmentIndexOffset = 0;
        for (var childIndex = 0; childIndex <= children.length - 1; childIndex++) {
            var child = children[childIndex];
            var childPath = __spreadArray(__spreadArray([], __read(path), false), [childIndex], false);
            var childRange = slate_1.Editor.range(editor, childPath);
            var rangesIntersect = !!slate_1.Range.intersection(fragmentRange, childRange);
            if (!rangesIntersect) {
                if (slate_1.Element.isElement(child) && (0, EditorWidgetRegistry_1.isContainerManagedWidget)(child.type)) {
                    var childClone = (0, lodash_1.cloneDeep)(child);
                    childClone.children = [Text_1.text.createSlateJson()];
                    fragmentChildren.splice(childIndex + fragmentIndexOffset, 0, childClone);
                }
                else {
                    fragmentIndexOffset--;
                }
            }
            else if (slate_1.Element.isElement(child) && ((_a = (0, EditorWidgetRegistry_1.getGenericConfigByType)(child.type, true)) === null || _a === void 0 ? void 0 : _a.nodeType) === "layoutElement") {
                var fragmentChild = fragmentChildren[childIndex + fragmentIndexOffset];
                (0, tiny_invariant_1.default)(slate_1.Element.isElement(fragmentChild), "editor's child was an Element but fragment's child wasn't");
                patchFragment(child.children, fragmentChild.children, childPath);
            }
        }
    };
    patchFragment(editor.children, fragment, []);
    var commonAncestorPath = slate_1.Path.common(fragmentRange.anchor.path, fragmentRange.focus.path);
    var commonAncestor = slate_1.Editor.node(editor, commonAncestorPath);
    var ancestors = __spreadArray([commonAncestor], __read(Array.from(slate_1.Node.ancestors(editor, commonAncestorPath, { reverse: true }))), false);
    var commonContainerDepth = ancestors.find(function (_a) {
        var _b;
        var _c = __read(_a, 1), ancestor = _c[0];
        if (slate_1.Editor.isEditor(ancestor)) {
            return true;
        }
        if (!slate_1.Element.isElement(ancestor)) {
            return false;
        }
        var config = (0, EditorWidgetRegistry_1.getGenericConfigByType)(ancestor.type, true);
        var isContentContainer = (config === null || config === void 0 ? void 0 : config.nodeType) === "layoutElement" && !((_b = config.containerNodeConfiguration) === null || _b === void 0 ? void 0 : _b.hasContainerManagedChildren);
        return isContentContainer;
    })[1].length;
    var nodeSlice = Array.from(slate_1.Node.nodes({ children: fragment }))
        .filter(function (_a) {
        var _b = __read(_a, 2), path = _b[1];
        return path.length === commonContainerDepth + 1;
    })
        .map(function (_a) {
        var _b = __read(_a, 1), node = _b[0];
        return node;
    })
        .filter(slate_1.Element.isElement);
    return nodeSlice;
};
exports.getFragment = getFragment;
